import axios from 'axios';
import _ from 'lodash';

const state = () => ({
    keyword : null,
    searchActive : false,
    searchResult : {},
    recentSearchKeywords : [],
})

const getters = {

}

const actions = {
    async search({ commit, state, rootState }, data) {
        commit("setKeyword", data.keyword);
        if(data.keyword != null && data.keyword != "") {
            await axios.get(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/search", {params : {keyword : data.keyword, type : data.type}}).then((response) => {
                commit("setSearchResult", response.data);
                commit("setRecentSearchKeywords", response.data.recentSearchKeywords);
            })
        } else {
            commit("setSearchResult", {});
            commit("recentSearches");
        }
    },
    async recentSearches({commit, state, rootState }, data) {
        await axios.get(rootState.settings.url +"/api/v1/" + rootState.settings.internal.user_company + "/internalSearches", {}).then((response) => {
            commit("setRecentSearchKeywords", response.data.recentSearchKeywords);
        })
    },
    async deleteSearchKeyword({ commit, state, rootState }, data) {
        await axios.post(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/deleteSearchKeyword", {id: data.search.id, type: data.search.type}).then((response) => {
            commit("setRecentSearchKeywords", response.data.recentSearchKeywords);
        })
    },
}


const mutations = {
    searchActive(state, status) {
        if(status == "open"){
            if(state.keyword == null) {
                commit("setSearchResult", {});
                actions.recentSearches;
            }
            else {
                actions.search(state.keyword);
            }
        }
        state.searchActive = status;
    },
    setSearchResult(state, result) {
        state.searchResult = result;
    },
    setKeyword(state, keyword) {
        if(keyword == "") {
            keyword = null;
        }
        state.keyword = keyword;
    },
    setRecentSearchKeywords(state, result) {
        state.recentSearchKeywords = result;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
}
